<!-- <div class="button-row">
  <a mat-button color="primary" (click)="onNavigate('./register')">Zur Registrierung</a>
</div> -->
<form [formGroup]="loginForm" (ngSubmit)="onFormSubmit()">
  <mat-card-content>
    <mat-form-field class="full-width">
      <span matPrefix>
        <mat-icon class="iconsize-20">person</mat-icon> &nbsp;</span>
      <input matInput type="text" placeholder="Benutzername" formControlName="Name" [errorStateMatcher]="matcher">
      <mat-error *ngIf="name.invalid && name.touched && name.errors?.required">
        Benutzername wird
        <strong>benötigt.</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <span matPrefix>
        <mat-icon class="iconsize-20">lock</mat-icon> &nbsp;</span>
      <input matInput [type]="hide ? 'text' : 'password'" placeholder="Passwort" formControlName="Password" [errorStateMatcher]="matcher"
        (keyup)="HitEnter(loginForm, $event)">
      <mat-error *ngIf="password.invalid && password.touched && password.errors?.required">
        Passwort wird
        <strong>benötigt.</strong>
      </mat-error>
    </mat-form-field>

    <br>

    <div class="button-row">
      <button cdkFocusInitial type="submit" mat-raised-button color="primary" [disabled]="!loginForm.valid">Anmelden</button>
    </div>

  </mat-card-content>
</form>


// WEBPACK FOOTER //
// ./src/app/_authentication/login/login.component.html